
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 94.2 94.2"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"47.1","cy":"47.1","r":"47.1","fill":"#cad3e0"}}),_c('path',{attrs:{"d":"M28.1 33.7h16.3m-16.3 4.2h16.3m-16.3 4.2h16.3m-16.3 4.2h8.5m-8.5 4.2h6.3","fill":"none","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M39 63.1H25.2c-1.9 0-3.5-1.6-3.5-3.5V23.4c0-1.9 1.6-3.5 3.5-3.5h16.7v5.3c0 2.3 1.8 4.1 4.1 4.1h5.5v15.3c.4 0 .7-.1 1.1-.1.5 0 .9 0 1.4.1V28.2c0-.8-.3-1.6-.9-2.2l-7.8-7.8c-.6-.6-1.3-.9-2.2-.9h-18c-3.3 0-6 2.7-6 6v36.2c0 3.3 2.7 6 6 6H40c-.4-.7-.7-1.5-1-2.4zM44.5 21l5.9 5.9h-4.3c-.9 0-1.6-.7-1.6-1.6V21z","fill":"#fff"}}),_c('path',{attrs:{"d":"M52.6 75.7c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-28.5a12.5 12.5 0 100 25 12.5 12.5 0 000-25z","fill":"#fff"}}),_c('path',{attrs:{"fill":"none","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-miterlimit":"10","d":"M50.4 51.6l-5.3 8.1m7.7-1.7l-5.3 8.1m12.6-8.6l-5.3 8.2"}}),_c('path',{attrs:{"d":"M67.2 62.6l8.1 2.4c.3.1.7.2 1 .4 2.5 1.5 3.8 4.2 2.8 6.1s-3.9 2.4-6.6 1.3c-.3-.1-.7-.3-.9-.6l-6.7-5.1","fill":"none","stroke":"#fff","stroke-width":"3.5","stroke-linecap":"round","stroke-miterlimit":"10"}})])
          )
        }
      }
    